﻿/*
 * @class rlAccordion
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlAccordion = function () {
        $(".accordionblock").each(function () {
            if ($(this).hasClass('full')) {
                $(this).find('.accordion-intro .bodycopy').addClass('col-lg-9');
                $(this).find('.accordion-item-body').addClass('col-lg-9');
            }
        });

        //Defect fix for bug 197761
        //iframe bug is resetting the page position in episerver preview mode when interacting with accordion panels.
        if (window.location !== window.parent.location) {
            var thisid;
            $('.accordion-link').on('click', function () {
                thisid = $(this).attr('id');

                setTimeout(function () {
                    document.getElementById(thisid).scrollIntoView();
                }, 800);
            });

            //Defect fix for bug 189494
            $('#main-content').addClass('nooverflow');
        }
    }
}(jQuery));